<template>
  <div>
    <a-table
      :row-selection="
        rowSelection
          ? {
              selectedRowKeys: rowSelectionKeys,
              onChange: onSelectChange,
              getCheckboxProps: (r) => ({
                props: { disabled: r.isCheckDisabled }
              })
            }
          : null
      "
      :columns="tableColumns"
      :data-source="tableData"
      :scroll="{ x: scrollX }"
      :pagination="false"
      :loading="tableLoading"
      :row-key="(record) => record.id"
    >

      <div slot="action" slot-scope="record, index">
        <slot name="action" :record="record" :index="index"></slot>
      </div>
    </a-table>
  </div>
</template>

<script>
export default {
  props: {
    showViewButton: {
      type: Boolean,
      default: true
    },
    showEditButton: {
      type: Boolean,
      default: true
    },
    showDeleteButton: {
      type: Boolean,
      default: true
    },
    tableColumns: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array,
      default: () => []
    },
    rowSelection: {
      type: Boolean,
      default: false
    },
    rowSelectionKeys: {
      type: Array,
      default: () => []
    },
    pageSizeOptions:{
      type: Array,
      default: () => []
    },
    pageNum: {
      type: Number,
    },
    pageSize: {
      type: Number,
    },
    total: {
      type: Number,
    },
    tableLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scrollX: 0,
      pageConent: {
        defaultPageSize: 10,
        pageNum: 1,
        total: 200
      },
      selectedRows: [],
      allSelectedRows: [],
      collectedRows: [], // 已收藏集合
      buttonColor: 'black'
    }
  },
  methods: {
    // 操作项
    tableLink(record) {
      this.$emit('removeData', record)
    },
    // 分页
    pageChange(page, pageSize, total) {
      this.$emit('getListPage', page, pageSize, total)
    },
    onShowSizeChange(page, pageSize){
      this.$emit('getShowPageNum', page, pageSize,)
    },
    onSelectChange(selectedRowKeys, e) {
      this.$emit('update:rowSelectionKeys', selectedRowKeys)
    },
    updateScrollX() {
      this.scrollX = this.tableColumns.length * 180
    }
  },
  watch: {
    tableColumns: {
      deep: true,
      handler() {
        this.updateScrollX()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* 分页 */
.page-ination {
  margin: 30px 0;
  text-align: right;
}
.black {
  color: rgba(0, 0, 0, 0.75);
}
.red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/a-table-scroll/index.vue